export const academyStats = [
  { value: '50+', label: 'Graduates Building Careers' },
  { value: '17', label: 'Industry Programs' },
  { value: '95%', label: 'Placement Support Rate' },
  { value: '4.9', label: 'Student Experience Rating' },
]

export const humanMoments = [
  {
    src: '/Gallery/Academy/Class rooms/20250822_165220.jpg',
    alt: 'Students learning in the SMA classroom',
    caption: 'ON SET',
    span: 'tall',
  },
  {
    src: '/Gallery/Academy/Class rooms/20250822_164638.jpg',
    alt: 'Students learning in the SMA classroom',
    caption: 'Live Instruction',
    span: 'wide',
  },
  {
    src: '/Gallery/Academy/Creative Training Sessions/DSC02423.jpg',
    alt: 'Filmmaking session on set',
    caption: 'On Set',
    span: 'normal',
  },
  {
    src: '/Gallery/Class rooms/20250822_165442.jpg',
    alt: 'Collaborative editing environment',
    caption: 'Post-Production',
    span: 'normal',
  },
  {
    src: '/Gallery/268A5755.JPG',
    alt: 'Creative student at work',
    caption: 'Creative Culture',
    span: 'wide',
  },
  {
    src: '/Gallery/Academy/Learning In Action/DSC02428 copy.jpg',
    alt: 'Photography workshop in studio',
    caption: 'One on One Mentorship',
    span: 'tall',
  },
  {
    src: '/Gallery/Class rooms/20250822_165729.jpg',
    alt: 'Mentor guiding students',
    caption: 'Mentorship',
    span: 'normal',
  },
  {
    src: '/Gallery/Academy/academy.jpg',
    alt: 'Synergy Multimedia Academy campus',
    caption: 'Our Home',
    span: 'wide',
  },
  {
    src: '/Gallery/Academy/Learning In Action/DSC02428 copy.jpg',
    alt: 'Student filming during golden hour field practice',
    caption: 'Field Practice',
    span: 'tall',
  },
]

export const instructors = [
  {
    name: 'Mr. Herbert Mukkiriza',
    role: 'Senior Graphic Design Instructor',
    image: '/Tutors/Herbert.jpg',
    experience: '15+ years',
    specialty: 'Branding, visual communication, advertising, and digital design. Expert in Adobe Creative Suite, CorelDRAW, and modern brand development.',
    highlights: ['Brand campaigns across East Africa', 'Expert in Adobe Creative Suite & CorelDRAW', 'Modern brand development specialist'],
    social: { instagram: 'synergymultimediaacademy' },
  },
  {
    name: 'Mr. Robert Kayemba',
    role: 'Photography Tutor',
    image: '/Tutors/Robert.jpg',
    experience: '6+ years',
    specialty: 'Portrait, commercial, and documentary photography. Expert in lighting, composition, and post-processing with Lightroom and Photoshop.',
    highlights: ['Professional portrait & commercial photography', 'Documentary storytelling', 'Lightroom & Photoshop specialist'],
    social: { instagram: 'synergymultimediaacademy' },
  },
  {
    name: 'Mr. David Ssebunya',
    role: 'Videography & Video Production Instructor',
    image: '/Tutors/David.jpg',
    experience: '7+ years',
    specialty: 'Cinematography, editing, and digital storytelling. Expert in Premiere Pro, After Effects, DaVinci Resolve, and professional video production workflows.',
    highlights: ['Professional cinematography & editing', 'Digital storytelling expert', 'DaVinci Resolve & After Effects specialist'],
    social: { instagram: 'synergymultimediaacademy' },
  },
  {
    name: 'Mr. Kisakye Isaac Joseph',
    role: 'AI & Digital Creation Instructor',
    image: '/Tutors/Joseph.jpg',
    experience: '5+ years',
    specialty: 'Generative AI, prompt engineering, and AI-powered creative workflows. Expert in Midjourney, Stable Diffusion, Runway, ChatGPT, and integrating AI into modern multimedia production.',
    highlights: ['Generative AI & prompt engineering', 'AI-powered creative workflows', 'Midjourney, Runway & Stable Diffusion expert'],
    social: { instagram: 'synergymultimediaacademy' },
  },
]

export const testimonials = [
  {
    name: 'Nakayiza Kelly Peace',
    role: 'Photography Graduate · Freelance Brand Photographer',
    quote: 'At SMA, I discovered that photography is more than clicking a shutter — it is about telling stories that move people. The hands-on training and mentorship transformed my passion into a profession.',
    outcome: 'Now freelancing for brands in Kampala',
    image: '/Gallery/Academy/Future Storytellers/Kelly Peace.jpg',
  },
  {
    name: 'Jonathan Ssebagala',
    role: 'Video Production Graduate · Aspiring Filmmaker',
    quote: 'The video production program at SMA gave me the technical skills and creative confidence to bring stories to life on screen. From cinematography to editing, every lesson pushed me closer to becoming the filmmaker I always dreamed of being.',
    outcome: 'Building a portfolio in documentary and commercial film',
    image: '/Gallery/Academy/Future Storytellers/Jona.jpg',
  },
]

export const alumniShowcase = [
  { title: 'Brand Identity System', type: 'Graphic Design', image: '/Gallery/ai-generated/Logo Design for Local Business.png' },
  { title: 'Portrait Series', type: 'Photography', image: '/Gallery/268A5758.JPG' },
  { title: 'Documentary Short', type: 'Film', image: '/Gallery/Academy/Learning In Action/DSC02432 copy.jpg' },
]

export const courseImages = {
  'PHOTO-101': '/Gallery/Academy/Creative Training Sessions/268A5754.JPG',
  'PHOTO-102': '/Gallery/Academy/Learning In Action/DSC02432 copy.jpg',
  'PHOTO-DRONE-001': '/Gallery/268A5758.JPG',
  'PHOTO-ADV-001': '/Gallery/268A5758.JPG',
  'VIDEO-CAM-001': '/Gallery/Academy/Creative Training Sessions/DSC02423.jpg',
  'VIDEO-EDIT-001': '/Gallery/Academy/Learning In Action/DSC02406 copy.jpg',
  'VIDEO-CINE-001': '/Gallery/Academy/Workshops/ww.jpg',
  'VIDEO-VFX-001': '/Gallery/Academy/Creative Training Sessions/268A5756.JPG',
  'GRAPH-GD-001': '/Gallery/ai-generated/Logo Design for Local Business.png',
  'GRAPH-BRAND-001': '/Gallery/Academy/Future Storytellers/Kelly  (1).jpeg',
  'ANIM-2D-001': '/Gallery/Academy/Learning In Action/DSC02428 copy.jpg',
  '3D ANIM-407': '/Gallery/124414.jpg',
  'SOCIAL-DCM-001': '/Gallery/Academy/Future Storytellers/Kelly  (2).jpeg',
  'SOCIAL-DM-001': '/Gallery/Academy/Class rooms/20250822_163612.jpg',
  'AI-TOOLS-001': '/Gallery/Academy/Multimedia Workshops/DSC02588.jpg',
  'UIUX-001': '/Gallery/Academy/Learning In Action/DSC02428 copy.jpg',
  'MASTER-MULTI-001': '/Gallery/Academy/Workshops/1X4A5555.jpg',
  default: '/Gallery/Academy/124414.jpg',
}

export const faqs = [
  {
    q: 'What makes SMA different from other creative schools?',
    a: 'We are Uganda\'s first AI-native multimedia academy — combining hands-on industry training with future-ready creative technology. Small classes, real equipment, and active practitioners as mentors.',
  },
  {
    q: 'Do I need prior experience to enroll?',
    a: 'No prior experience required. We accept passionate creatives from all backgrounds. Basic computer literacy helps, but your drive to learn matters most.',
  },
  {
    q: 'What equipment and facilities are provided?',
    a: 'Professional cameras, lighting rigs, editing suites with licensed software, studio space, and AI creative tools — everything you need to build a world-class portfolio.',
  },
  {
    q: 'Can I pay in installments?',
    a: 'Yes. Flexible 2–3 installment plans spread across your course duration. Contact admissions for a personalized payment schedule.',
  },
  {
    q: 'What career support do graduates receive?',
    a: 'Portfolio reviews, CV building, interview preparation, industry networking events, freelance starter guidance, and job placement assistance through our partner network.',
  },
]

export const marqueeItems = [
  'Photography', 'Cinematography', 'Graphic Design', 'AI Creation',
  'Animation', 'Video Editing', 'Brand Strategy', 'Visual Storytelling',
  'Social Media', 'Motion Graphics', 'Portrait Art', 'Documentary Film',
]
